import { gql } from '@apollo/client';

export const GET_LOCATION_SUMMARY = gql`
  query LocationSummary {
    findAll: locationsSummary {
      locationName
      locationUuid
      suppliersCount
      supportedRevenue
    }
  }
`;

export const FETCH_LOCATIONS_SUPPLIERS = gql`
  query FindAllSupplier {
    findAll: findAllSupplier {
      approxAnualSpend
      availableAlternatives
      city
      country
      qualifiedAlternatives
      sourcingStatus
      state
      street
      supplierAddress
      supplierName
      supplierRecoveryTime
      timeToReplaceSupplier
      uuid
      zipCode
    }
  }
`;

export const FETCH_SUPPLIERS = gql`
  query FindAllSupplier {
    findAllSupplier {
      approxAnualSpend
      availableAlternatives
      city
      country
      qualifiedAlternatives
      sourcingStatus
      state
      street
      supplierAddress
      supplierName
      supplierRecoveryTime
      timeToReplaceSupplier
      uuid
      zipCode
    }
  }
`;

export const FIND_SUPPLIERS_BY_LOCATION = gql`
  query FindSupplierByLocation($locationUuid: String!) {
    findSupplierByLocation(locationUuid: $locationUuid) {
      approxAnualSpend
      availableAlternatives
      bcpUpdatedAt
      city
      country
      qualifiedAlternatives
      sourcingStatus
      state
      street
      supplierAddress
      supplierName
      supplierRecoveryTime
      timeToReplaceSupplier
      uuid
      zipCode
    }
  }
`;

export const ASSIGN_SUPPLIERS_TO_LOCATION = gql`
  mutation AssignSupplierToLocation($data: SupplierLocationInput!) {
    assignSupplierToLocation(data: $data)
  }
`;

export const UNASSIGN_SUPPLIERS_TO_LOCATION = gql`
  mutation UnAssignSupplierFromLocation($data: SupplierLocationInput!) {
    unAssignSupplierFromLocation(data: $data)
  }
`;

export const CREATE_SUPPLIER_DEPENDENCIES = gql`
  mutation CreateSuppliersDependencies($input: SupplierLocationInput!) {
    createSuppliersDependencies(input: $input) {
      comment
      createdAt
      deletedAt
      level
      percentage
      supplierRevenue
      updatedAt
      uuid
    }
  }
`;

export const FIND_SUPPLIER_DEPENDENCIES = gql`
  query FindSupplierDependencies($locationUuid: String!) {
    findAll: findSupplierDependencies(locationUuid: $locationUuid) {
      division {
        name
        children: productGroupFinancials {
          name
          percentage
          children: productFinancials {
            name
            suppliers {
              comment
              percentage
              revenue
              supplierName
              uuid
              supplierDependencyUUID
            }
            supportedRevenue
            uuid
          }
          suppliers {
            comment
            percentage
            revenue
            supplierName
            uuid
            supplierDependencyUUID
          }
          supportedRevenue
          uuid
        }
        suppliers {
          comment
          percentage
          revenue
          supplierName
          uuid
          supplierDependencyUUID
        }
        supportedRevenue
        uuid
      }
    }
  }
`;

export const ADD_COMMENT_FOR_SUPPLIER = gql`
  mutation InsertComment($input: UpdateDependencyInput!) {
    insertComment(input: $input) {
      comment
      deletedAt
      level
      supplierRevenue
      percentage
      updatedAt
      uuid
    }
  }
`;

export const UPDATE_DIVISION_LEVEL = gql`
  mutation UpdatePercentageDivision($data: UpdateDependencyInput!) {
    updatePercentageDivision(input: $data) {
      comment
      level
      percentage
      supplierRevenue
      updatedAt
    }
  }
`;

export const UPDATE_PERCENTAGE_PRODUCT = gql`
  mutation UpdatePercentageProduct($data: UpdateDependencyInput!) {
    updatePercentageProduct(input: $data) {
      comment
      createdAt
      deletedAt
      level
      percentage
      supplierRevenue
      updatedAt
      uuid
    }
  }
`;

export const UPDATE_PERCENTAGE_PRODUCT_GROUP = gql`
  mutation UpdatePercentageProductGroup($data: UpdateDependencyInput!) {
    updatePercentageProductGroup(input: $data) {
      comment
      createdAt
      level
      deletedAt
      percentage
      updatedAt
      supplierRevenue
      uuid
    }
  }
`;

export const UPDATE_INTERMEDIATE = gql`
  mutation UpdateIntermidiatePercentage($data: UpdateDependencyInput!) {
    updateIntermidiatePercentage(input: $data) {
      comment
      createdAt
      deletedAt
      level
      percentage
      supplierRevenue
      updatedAt
      uuid
    }
  }
`;

export const SUPPLIER_DEPENDENCIES_SUMMARY = gql`
  query GetSummaryDependency($locationUuid: ID!) {
    findAll: getSummaryDependency(locationUuid: $locationUuid) {
      bcpUploaded
      bcpUpdatedAt
      percentageOfLocationSupported
      sourcingStatus
      supplierName
      totalRevenue
      uuid
    }
  }
`;

export const DELETE_SUPPLIER_DEPENDENCIES = gql`
  mutation DeleteSupplierDependency($input: SupplierLocationInput!) {
    deleteSupplierDependency(input: $input)
  }
`;
